// components/DeleteControllerDialog.js

import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Snackbar,
  Alert
} from '@mui/material';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/config';

const DeleteControllerDialog = ({ open, handleClose, controller, onDeleteSuccess }) => {
    console.log('Controller to delete:', controller);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const handleSnackbarClose = () => {
    setSnackbar(prev => ({
      ...prev,
      open: false
    }));
  };

  const handleDelete = async () => {
    try {
      // API call to delete the controller using its ID
      const response = await axios.delete(`${API_BASE_URL}api/sensor/delete/${controller._id}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        }
      });

      console.log('Controller deleted:', response.data);
      setSnackbar({
        open: true,
        message: 'Controller deleted successfully.',
        severity: 'success'
      });
      handleClose();
      onDeleteSuccess();
    } catch (error) {
      console.error('Error deleting controller:', error);
      setSnackbar({
        open: true,
        message: error.response?.data?.message || 'Failed to delete controller.',
        severity: 'error'
      });
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Delete Controller</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the controller ?
          This action cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleDelete} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default DeleteControllerDialog;
